import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import Dashboard from '../../components/Dashboard';
import PropertyList from '../../components/Property/PropertyList';
import { getPropertyList, deleteProperty } from '../../redux/modules/property/action';

const ROWS_PER_PAGE = 10;
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  button: {
    margin: theme.spacing.unit,
    float: 'left'
  },
  title: {
    margin: theme.spacing.unit,
    float: 'left'
  }
});

class Property extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    userList: PropTypes.array,
    classes: PropTypes.object
  }

  state = {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE
  };

  async componentDidMount() {
    const { dispatch } = this.props;
    const { page, rowsPerPage } = this.state;
    await dispatch(getPropertyList(page, rowsPerPage));
  }

  openView = (propertyId) => {
    const { dispatch } = this.props;
    dispatch(push(`/property/view-property/${propertyId}`));
  }

  updateProperty = (propertyId) => {
    const { dispatch } = this.props;
    dispatch(push(`/property/edit-property/${propertyId}`));
  }

  removeProperty = (postId) => {
    const { dispatch } = this.props;
    dispatch(deleteProperty(postId));
  }

  handleChangePage = (event, page) => {
    const { dispatch } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ page });
    dispatch(getPropertyList(page, rowsPerPage));
  };

  handleChangeRowsPerPage = event => {
    const { dispatch } = this.props;
    const { page } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getPropertyList(page, event.target.value));
  };

  render() {
    const { classes, total, dispatch, propertyList } = this.props;
    const { rowsPerPage, page } = this.state;

    return (
      <Dashboard>
        <React.Fragment>
          <Typography className={classes.title} variant="h4">Vacancy Post</Typography>

          <Button
            variant="fab"
            color="primary"
            aria-label="Add"
            className={classes.button}
            mini
            onClick={() => dispatch(push('/property/new'))}
          >
            <AddIcon />
          </Button>
          <Paper className={classes.root}>

            <PropertyList
              list={propertyList}
              openView={this.openView}
              updateProperty={this.updateProperty}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              page={page}
              totalRecords={total}
              deleteProperty={this.removeProperty}
            />
          </Paper>
        </React.Fragment>
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    propertyList: state.property.list.rows,
    total: state.property.list.count
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Property));